module.exports = __webpack_public_path__ + "static/img/product3.e11bf50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product3.png
// module id = 01c0
// module chunks = 1